$(document).ready(function(){
$('body').on('click','.free-add-btn-wpr .add-btn',function(e){
    e.preventDefault();
    var color = $(this).parents('.cart-free-wpr .free-product-slide').find('.color-wpr .color-value').text();
    var value = $(this).parents('.cart-free-wpr .free-product-slide').find('.dropinner-val .currentval').text();
    var id = $(this).parents('.cart-free-wpr .free-product-slide').find('.productSelect [data-option1="' + color + '"][data-option2="' + value + '"]').attr('value');
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: id,
      properties : {      
      'free_product': 'yes'     
      }
    },
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      }
    }).done(function( data ) {
      $.get( "/cart?view=minicart", function( data ) {
        $('.cartitemmodel').html(data);
      });
       $.get( "/cart.json", function( cart ) {
         $('header ul li.cart > a span').attr('data-count', cart.items.length).parent().addClass('fill');
        if(cart.items.length <= 1){
          $('.dropdown.minicartmain').addClass('BasketHas');
        }else{
          $('.dropdown.minicartmain').removeClass('BasketHas');
        }
       });
    });  
  });
  $('body').on("click",".change-free-product", function(e) {
    e.preventDefault();
    var img = $(this).attr('data-img');
    var color = $(this).attr('data-color');
    var freeClass = $(this).attr('free-class');
    $(this).parents('.free-product-slide').find('li.active').removeClass('active');
    $(this).parent().addClass('active');
    $(this).parents('.free-product-slide').find('img').attr('src',img);
    $(this).parents('.free-product-slide').find('.color-value span').attr('class', color);
    $(this).parents('.free-product-slide').find('.color-value a').attr('class', color);
    $(this).parents('.free-pro-color').find('.color-wpr .color-value').text(freeClass);
    $(this).closest('.color-drop').removeClass('active');
  });
});